import {gql} from "@apollo/client";

const DELETE_USER = gql`
    mutation deleteUser($idUser: ID!){
        deleteUser(idUser: $idUser)
    }
`;

export default DELETE_USER;
